import React, { useState } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import '../App.css';
import { useAuth } from '../context/AuthContext';

function Dashboard({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [active, setActive] = useState('overview');
  const { user, logout } = useAuth();

  return (
    <div className="layout-root">
      <Header onToggleSidebar={() => setCollapsed(c => !c)} user={user} onLogout={logout} />
      <div className="layout-body">
        <Sidebar collapsed={collapsed} active={active} onSelect={(k) => setActive(k)} />
        <main className="main-content">
          {React.isValidElement(children) ? React.cloneElement(children, { activeSection: active, onNavigate: setActive }) : children}
        </main>
      </div>
    </div>
  );
}

export default Dashboard;
